module.exports = __webpack_public_path__ + "img/shape-6.1a4b801a.svg";